import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import "assets/scss/argon-design-system-react.scss?v1.1.0";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "views/IndexSections/Footer.js"; // Add a footer component
import BannerAd from "components/Banners/Banner";

// Lazy load components
const Index = lazy(() => import("views/Index.js"));
const AboutUsPage = lazy(() => import("views/IndexSections/AboutUs"));
const PrivacyPage = lazy(() => import("views/IndexSections/PrivacyPolicy"));
const TermsPage = lazy(() => import("views/IndexSections/Terms"));
const ContactUsPage = lazy(() => import("views/IndexSections/ContactUs"));
const NotFoundPage = lazy(() => import("views/IndexSections/NotFound")); // Add a 404 page

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <div
      style={{
        backgroundColor: "#6d6cd1",
        minHeight: "100vh",
        paddingTop: "70px",
      }}
    >
      <DemoNavbar />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" exact element={<Index />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="contact" element={<ContactUsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      <Footer />
    </div>
  </BrowserRouter>,
);
